module.exports = __webpack_public_path__ + "static/assets/b902700357964e91d7799c48947b4f3a.png";